
import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {AppService} from '../services/app.service';
import {Store} from "@ngrx/store";
import {AppState} from ".././store/store";
import {Observable} from "rxjs";
import {InitState} from ".././store/init/init";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard implements CanActivate {

  private readonly _init$: Observable<InitState> = this._store.select((state: AppState) => state.init);

  constructor(
    private readonly _router:  Router,
    private readonly _appS:    AppService,
    private readonly _store:   Store<AppState>
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

    return this._init$.pipe(
      map((initState: InitState) => {
        if (initState.logged === null) {
          this._appS.setPreviousNoLoggedUrl(route, state);
          this._router.navigate(['/loading']);
          return false;
        }

        return true;
      })
    );
  }

}
